export const LOYALTY_LANDING_PAGE = 'societe'
